export const EDIT_LANDING_REQUEST = 'EDIT_LANDING_REQUEST';
export const EDIT_LANDING_SUCCESS = 'EDIT_LANDING_SUCCESS';
export const EDIT_LANDING_FAILED = 'EDIT_LANDING_FAILED';
export const GET_LANDING_REQUEST = 'GET_LANDING_REQUEST';
export const GET_LANDING_SUCCESS = 'GET_LANDING_SUCCESS';
export const GET_LANDING_FAILED = 'GET_LANDING_FAILED';
